import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function UnilagGrantPresentation({ show, onClose, onOpen }) {
  // const [chatroomShow, setChatroomShow] = useState(false);
  // const handleChatroom = () => setChatroomShow(false);
  return (
    <div>
      <Modal
        size="xl"
        show={show}
        onHide={onClose}
        //  // backdrop="static"
        aria-labelledby="example-modal-sizes-title-lg"
        keyboard={false}
        animation={true}
        centered
      >
        <Modal.Body>
          <div className="Solera__Cont">
            <FiX className="Solera__Close" onClick={onClose} />
          </div>

          <div className="Exoc-Name">Unilag Grant Presentation</div>
          {/* <div className="Exco-Tittle">President</div> */}
          <br />

          {/* <div className="NO-Events">BBQ PARTY 2022</div> */}
          <br />
          <div>
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/1.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/2.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/3.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/4.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/5.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/6.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/7.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/8.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Grant/9.png"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
              <br />
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Grant/10.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Grant/11.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Grant/12.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
                <br />
                <div className="container-fluid p-0">
                  <div className="row g-4">
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/Grant/13.png"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/Grant/14.png"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/Grant/15.png"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="container-fluid p-0">
                    <div className="row g-4">
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Grant/16.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Grant/17.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Grant/18.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="container-fluid p-0">
                    <div className="row g-4">
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Grant/19.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Grant/20.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Grant/21.png"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default UnilagGrantPresentation;
